import _ from 'lodash';
_.noConflict();

// eslint-disable-next-line no-extend-native
String.prototype.format = function () {
  const args = arguments;

  function getMatch (object, key, match) {
    const value = object[key];
    return !_.isUndefined(value) ? value : match;
  }

  if (args.length === 1 && _.isObject(args[0])) {
    const dict = args[0];
    return this.replace(/{(\w+)}/g, (match, key) => getMatch(dict, key, match));
  }
  return this.replace(/{(\d+)}/g, (match, number) => getMatch(args, number, match));

};
